import LcapClock from './index.vue';

export {
    LcapClock,
};

export default LcapClock;
